export default __webpack_public_path__ + "static/media/CharalambidesChristis cyprus.7243ac75.png";